<template>
  <div>
    <fade-down-modal :show="show" ref="box">
      <div class="barGroupMange comMsgbox">
        <div class="header">
          <header-tag :title="title"></header-tag>
        </div>
        <div class="content">
          <div class="table-header row">
            <div>分组名称</div>
            <div>网吧数</div>
            <div>操作</div>
          </div>
          <div class="table-body" ref="tBody">
            <div class="row" v-for="(item, index) in cacheGroupList" :key="index">
              <div>
                <span v-text="item.groupName" v-show="!item.editState"></span>
                <input type="text" v-show="item.editState" v-model="item.editName" />
              </div>
              <div>
                <span v-text="item.totalBarCnt"></span>
              </div>
              <div v-show="!item.editState">
                <a href="#" @click.prevent="item.editState = true">更改名称</a>
                <a href="#" @click.prevent="toDel(item)">删除分组</a>
              </div>
              <div v-show="item.editState">
                <a href="#" @click.prevent="save(item)">保存</a>
                <a href="#" @click.prevent="item.editState = false">取消</a>
              </div>
            </div>
          </div>
        </div>
        <div><img src="@/assets/img/icon/u207.png" alt="" /></div>

        <div class="btn">
          <div class="left">
            <input type="text" v-model="newGroupName" placeholder="分组名最多10个字符" />
            <a href="#" @click.prevent="add" class="default-btn">添加</a>
            <p class="wrong-word">
              <span ref="wrong" v-text="wrong"></span>
            </p>
          </div>
          <div class="right">
            <a href="#" class="default-btn" @click.prevent="show = false">关闭</a>
          </div>
        </div>
      </div>
    </fade-down-modal>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag'
import { mapState, mapActions } from 'vuex'
import FadeDownModal from '_c/modals/fadeDown'
import { saveGroupName, delBarGroup } from '@/requests/bar'
export default {
  name: 'barModals',
  components: {
    HeaderTag,
    FadeDownModal,
  },
  data () {
    return {
      title: '网吧分组管理',
      show: false,
      cacheGroupList: [],
      newGroupName: '',
      wrong: '',
      successFn: '',
    }
  },
  computed: {
    ...mapState({
      groupList: (state) => state.user.barGroupList,
    }),
  },
  watch: {
    groupList () {
      let arr = JSON.parse(JSON.stringify(this.groupList))
      arr.forEach((item) => {
        item.editState = false
        item.editName = item.groupName
      })
      this.cacheGroupList = arr
    },
  },
  mounted () {
    window.$modal.barGroupManageModal = {}
    window.$modal.barGroupManageModal.show = () => {
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true)
        })
      })
    }
    window.$modal.barGroupManageModal.del = ({ groupId, toGroupId }) => {
      this.del({ groupId, toGroupId })
    }
    //监听键盘按键事件
    let self = this
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27)
        {
          self.show = false
        }
      })
    })
  },
  methods: {
    ...mapActions(['user/actionUpdateBarGroupList']),
    init (fn) {
      this.wrong = ''
      this.show = true
      this.successFn = fn
    },
    setWrong (txt) {
      this.wrong = txt
      this.$domFn.shake(this.$refs.wrong)
    },
    async add () {
      this.wrong = ''
      if (!this.checkName(this.newGroupName))
      {
        return
      }
      let res = await saveGroupName({
        groupId: '',
        groupName: this.newGroupName,
      })
      if (res.code == 200)
      {
        this.newGroupName = ''
        await this['user/actionUpdateBarGroupList']()
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$refs.tBody.scrollTop = this.$refs.tBody.scrollHeight
        })
      } else
      {
        this.setWrong(res.msg)
      }
    },
    toDel ({ groupId }) {
      window.$modal.delBarGroupTo.show(groupId)
    },
    async del ({ groupId, toGroupId }) {
      this.wrong = ''
      let res = await delBarGroup({
        groupId,
        toGroupId,
      })
      if (res.code == 200)
      {
        this['user/actionUpdateBarGroupList']()
        this.$forceUpdate()
      } else
      {
        this.setWrong(res.msg)
      }
    },
    checkName (txt) {
      if (txt === '')
      {
        this.setWrong('分组名不能为空')
        return false
      }
      if (txt.length > 10)
      {
        this.setWrong('分组名不能超过10个字符')
        return false
      }
      return true
    },
    async save (item) {
      this.wrong = ''
      if (!this.checkName(item.editName))
      {
        return
      }
      let res = await saveGroupName({
        groupId: item.groupId,
        groupName: item.editName,
      })
      if (res.code == 200)
      {
        this['user/actionUpdateBarGroupList']()
        this.$forceUpdate()
        this.successFn()
      } else
      {
        window.$msg({
          type: 'success',
          message: '操作成功',
          showClose: true,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '_style/msgbox/_msgBox.scss';
@import '_style/_color.scss';
@import '_style/table/_default.scss';
@import '_style/cssfn/common.scss';

.barGroupMange {
  height: 360px;
  margin: 0 auto;

  .content {
    padding: 0 20px;
    margin-top: 10px;
    height: 220px;

    .row {
      width: 100%;
      @include clearfix();

      >div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;

        span {
          @include ellipsis();
          display: inline-block;
          max-width: 100%;
        }

        a {
          color: $blue-1;
          margin-right: 10px;
        }

        input {
          height: 60%;
          width: 90%;
          border: 1px solid rgba(230, 230, 230, 1);
        }
      }

      >div:nth-child(1) {
        width: 24%;
        padding-left: 10px;
      }

      >div:nth-child(2) {
        width: 24%;
      }

      >div:nth-child(3) {
        width: 40%;
      }
    }

    .table-header {
      >div {
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .btn {
    .left {
      margin-left: 20px;

      input {
        width: 140px;
        height: 30px;
        border: 1px solid rgba(230, 230, 230, 1);
        padding-left: 5px;
        margin-right: 5px;
      }

      a {
        width: 60px;
        height: 30px;
        padding: 0;
        text-align: center;
        line-height: 30px;
      }
    }
  }
}

.table-body {
  overflow-y: auto;
  height: 200px;
}

.wrong-word {
  color: #ff3333;
  display: inline-block;
  margin-left: 10px;

  span {
    display: block;
  }
}
</style>
